import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { toMessageProps } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { Message } from 'Data/ViewModels/IApiDataModel';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, RadioGroup } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../Layout';
import { CompactiveEffort } from '../../types';

let AsPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, prefixName }) => {
  /**
   * Messages for oversize determination results
   *
   * These are not shown on the worksheet so we add an explicit section for these messages
   * (which contain important information about how the test is to be performed based on these results)
   */
  const oversizeDeterminationMessages = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.Screening.Messages'),
      (m) => (m as Array<Message>)?.filter((m) => ['OversizeSieve', 'OversizePercentWet'].includes(m.PropertyName)),
      (m) => m.map(toMessageProps)
    ),
    deepEquals
  );

  return (
    <>
      <Field
        input={<RadioGroup />}
        name={'Preparation.CompactiveEffort'}
        options={[
          { label: 'Standard', value: CompactiveEffort.Standard },
          { label: 'Modified', value: CompactiveEffort.Modified },
        ]}
      />
      <SectionGroup>
        <WorksheetAssociatedTestSection
          name="Preparation.AssociatedOversizeDetermination"
          testType="Oversize Determination"
          associatedTestModel={{
            measured: true,
          }}
        />
        <ListFieldSection messages={oversizeDeterminationMessages} />
      </SectionGroup>
    </>
  );
};

AsPreparationSection = withInjectedProps(AsPreparationSection);

export { AsPreparationSection };
export default AsPreparationSection;
